import { render, staticRenderFns } from "./phoneAbout.vue?vue&type=template&id=95d6ecfc&scoped=true"
import script from "./phoneAbout.vue?vue&type=script&lang=js"
export * from "./phoneAbout.vue?vue&type=script&lang=js"
import style0 from "./phoneAbout.vue?vue&type=style&index=0&id=95d6ecfc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d6ecfc",
  null
  
)

export default component.exports